export function routeDebugEnabled() {
  try {
    return typeof window !== 'undefined' && window.localStorage && window.localStorage.getItem('routeDebug') === '1';
  } catch {
    return false;
  }
}

export function logRouteDebug(...args) {
  if (routeDebugEnabled()) {
    // Prefix to make it easy to find in console
    console.log('[RouteDebug]', ...args);
  }
}

export function registerMount(name) {
  if (!routeDebugEnabled()) return;
  try {
    window.__routeDebugMounted = window.__routeDebugMounted || [];
    window.__routeDebugMounted.push(name);
    console.log('[RouteDebug] MOUNT:', name, 'mountedPages=', window.__routeDebugMounted.slice());
  } catch (e) { try { console.warn('[RouteDebug] registerMount failed', e); } catch { void 0; } }
}

export function unregisterMount(name) {
  if (!routeDebugEnabled()) return;
  try {
    window.__routeDebugMounted = window.__routeDebugMounted || [];
    window.__routeDebugMounted = window.__routeDebugMounted.filter(n => n !== name);
    console.log('[RouteDebug] UNMOUNT:', name, 'mountedPages=', window.__routeDebugMounted.slice());
  } catch (e) { try { console.warn('[RouteDebug] unregisterMount failed', e); } catch { void 0; } }
}

export function inspectTopElements() {
  if (!routeDebugEnabled()) return;
  try {
    const points = [
      { x: Math.floor(window.innerWidth / 2), y: 120 },
      { x: Math.floor(window.innerWidth / 2), y: Math.floor(window.innerHeight / 2) },
      { x: Math.floor(window.innerWidth / 2), y: Math.floor(window.innerHeight - 100) }
    ];
    const results = points.map(p => {
      const el = document.elementFromPoint(p.x, p.y);
      if (!el) return { point: p, el: null };
      const rect = el.getBoundingClientRect();
      const style = window.getComputedStyle(el);
      return {
        point: p,
        tag: el.tagName,
        class: el.className,
        id: el.id,
        rect: { x: rect.x, y: rect.y, w: rect.width, h: rect.height },
        pointerEvents: style.pointerEvents,
        zIndex: style.zIndex
      };
    });
    console.log('[RouteDebug] inspectTopElements:', results);

    // Also find fullscreen fixed elements that may block clicks
    const blockers = Array.from(document.querySelectorAll('*')).filter(el => {
      try {
        const s = window.getComputedStyle(el);
        return (s.position === 'fixed' || s.position === 'absolute') && (parseFloat(s.opacity || '1') > 0) && (el.offsetWidth >= window.innerWidth * 0.9 || el.offsetHeight >= window.innerHeight * 0.6) && s.pointerEvents !== 'none';
      } catch { return false; }
    }).slice(0, 10).map(el => ({ tag: el.tagName, id: el.id, class: el.className, rect: el.getBoundingClientRect(), zIndex: window.getComputedStyle(el).zIndex }));

    if (blockers.length) console.log('[RouteDebug] potential blocking elements:', blockers);
  } catch (e) { try { console.warn('[RouteDebug] inspectTopElements failed', e); } catch { void 0; } }
}

// Return inspection results for programmatic use (does not require routeDebug flag)
export function getInspectTopElements() {
  try {
    const points = [
      { x: Math.floor(window.innerWidth / 2), y: 120 },
      { x: Math.floor(window.innerWidth / 2), y: Math.floor(window.innerHeight / 2) },
      { x: Math.floor(window.innerWidth / 2), y: Math.floor(window.innerHeight - 100) }
    ];
    const results = points.map(p => {
      const el = document.elementFromPoint(p.x, p.y);
      if (!el) return { point: p, el: null };
      const rect = el.getBoundingClientRect();
      const style = window.getComputedStyle(el);
      return {
        point: p,
        tag: el.tagName,
        class: el.className,
        id: el.id,
        rect: { x: rect.x, y: rect.y, w: rect.width, h: rect.height },
        pointerEvents: style.pointerEvents,
        zIndex: style.zIndex,
        node: el
      };
    });

    const blockers = Array.from(document.querySelectorAll('*')).filter(el => {
      try {
        const s = window.getComputedStyle(el);
        return (s.position === 'fixed' || s.position === 'absolute') && (parseFloat(s.opacity || '1') > 0) && (el.offsetWidth >= window.innerWidth * 0.9 || el.offsetHeight >= window.innerHeight * 0.6) && s.pointerEvents !== 'none';
      } catch { return false; }
    }).slice(0, 20).map(el => ({ tag: el.tagName, id: el.id, class: el.className, rect: el.getBoundingClientRect(), zIndex: window.getComputedStyle(el).zIndex, node: el }));

    return { points: results, blockers };
  } catch (e) { try { console.warn('[RouteDebug] getInspectTopElements failed', e); } catch { void 0; } return { points: [], blockers: [] }; }
}
